import { auth } from '@/auth';
import { Env } from '@/env';
import { type ApiClient, type ApiClientConfig, type BaseApi, type MonteursGameApi } from '@shared/modelTypes/api-types';

function makeApiClient<TApi extends BaseApi>(config: ApiClientConfig<TApi>) {
	const target = {};
	return new Proxy(target, {
		get(target, props, receiver) {
			console.log('proxy called', target, props, receiver);
			return (params: any) => {
				return config.handler({ endpoint: props as any, params });
			};
		},
	}) as ApiClient<TApi>;
}

export const api = makeApiClient<MonteursGameApi>({
	handler: async (opts) => {
		try {
			const res = (await auth
				.fetch(Env.VITE_API_URL, {
					method: 'post',
					headers: {
						'Content-Type': 'application/json',
						accept: 'application/json',
					},
					body: JSON.stringify(opts),
				})
				.then((res) => res.json())) as {
				success: boolean;
				data: any;
				message: string;
			};

			if (res.success) {
				return res.data;
			} else {
				console.error('api call fail:', res);
				throw new Error(res.message);
			}
		} catch (e) {
			console.error('api call fail:', e);
			throw new Error('API call failed');
		}
	},
});
